import { render } from "./FormForgotAccount.vue?vue&type=template&id=34998222"
import script from "./FormForgotAccount.vue?vue&type=script&lang=js"
export * from "./FormForgotAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__